// core library
import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import GoodsInList from "./components/list";
import { Details } from "./details";

const GoodsIn = () => {

  /** hooks veriable **/
  const Location = useLocation();

  return (
    <>
      <Routes>
        <Route path={`/`} element={<Navigate replace="/" to={`${Location.pathname}/list`} />} />
        <Route path={"list"} element={<GoodsInList />} />
        <Route path={"detail/:id"} element={<Details />} />
      </Routes>
    </>
  );
};

export default GoodsIn;
